export const selectedProjectCookieName = 'ProjectId';
export const projectConfigurationPath = '/Admin/Configuration';
